"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AvatarPopup_styled_exports = {};
__export(AvatarPopup_styled_exports, {
  StyleAvatarWithKebab: () => StyleAvatarWithKebab,
  StyledAvatar: () => StyledAvatar,
  StyledAvatarButton: () => StyledAvatarButton,
  StyledAvatarPopUpContainer: () => StyledAvatarPopUpContainer,
  StyledPopover: () => StyledPopover
});
module.exports = __toCommonJS(AvatarPopup_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_Popover = require("../../atoms/Popover/Popover.component");
var import_Avatar = require("../../atoms/Avatar/Avatar.component");
var import_mixins = require("../../../themes/mixins");
var StyledAvatarPopUpContainer = import_styled_components.default.div.withConfig({
  displayName: "AvatarPopupstyled__StyledAvatarPopUpContainer",
  componentId: "sc-1kflds3-0"
})([""]);
var StyleAvatarWithKebab = import_styled_components.default.div.withConfig({
  displayName: "AvatarPopupstyled__StyleAvatarWithKebab",
  componentId: "sc-1kflds3-1"
})(function(_ref) {
  var isOpen = _ref.isOpen;
  return (0, import_styled_components.css)(["position:absolute;top:0;left:0;right:0;bottom:0;height:100vh;overflow-y:auto;display:", ";", ""], isOpen ? "block" : "none", (0, import_mixins.withStyledScrollBar)());
});
var StyledAvatarButton = import_styled_components.default.button.withConfig({
  displayName: "AvatarPopupstyled__StyledAvatarButton",
  componentId: "sc-1kflds3-2"
})(function(_ref2) {
  var theme = _ref2.theme, darkMode = _ref2.darkMode, variant = _ref2.variant;
  return (0, import_styled_components.css)(["", " background:transparent;border:0;cursor:pointer;padding:0;&:focus{box-shadow:", " ", ",", " 0px 0px 0px 3px;outline:none;}&:focus:active{box-shadow:none;}"], (0, import_mixins.withBorderRadius)("50%"), darkMode || variant === "ghost" ? theme.colors.n["100"] : theme.colors.beige["60"], theme.measurements.shadows.small, darkMode || variant === "ghost" ? theme.colors.beige["140"] : theme.colors.beige["180"]);
});
var StyledAvatar = (0, import_styled_components.default)(import_Avatar.Avatar).withConfig({
  displayName: "AvatarPopupstyled__StyledAvatar",
  componentId: "sc-1kflds3-3"
})(function(_ref3) {
  var theme = _ref3.theme, darkMode = _ref3.darkMode, variant = _ref3.variant;
  var backgroundColor = function backgroundColor2() {
    if (darkMode) {
      return theme.colors.white;
    }
    return variant === "ghost" ? theme.colors.white : theme.colors.n["100"];
  };
  var hoverBackgroundColor = function hoverBackgroundColor2() {
    if (variant === "ghost") {
      return theme.colors.white;
    }
    if (darkMode) {
      return theme.colors.beige["60"];
    }
    return theme.colors.n["80"];
  };
  var pressedBackgroundColor = function pressedBackgroundColor2() {
    if (variant === "ghost") {
      return theme.colors.beige["40"];
    }
    if (darkMode) {
      return theme.colors.beige["120"];
    }
    return theme.colors.n["85"];
  };
  return (0, import_styled_components.css)(["&:active:hover{background:", ";box-shadow:none;}&:hover{background:", ";", ";}&:active{background:", ";}border:", ";background:", ";"], pressedBackgroundColor(), hoverBackgroundColor(), variant === "ghost" ? "box-shadow: ".concat(theme.colors.n["100"], " ").concat(theme.measurements.shadows.extraSmall, " inset; border: 1px solid ").concat(theme.colors.n["100"], "   ") : "", pressedBackgroundColor(), variant === "ghost" ? "1px solid ".concat(theme.colors.beige["180"]) : "none", backgroundColor());
});
var StyledPopover = (0, import_styled_components.default)(import_Popover.Popover).withConfig({
  displayName: "AvatarPopupstyled__StyledPopover",
  componentId: "sc-1kflds3-4"
})(function(_ref4) {
  var width = _ref4.width;
  return (0, import_styled_components.css)(["border:0;list-style-type:none;overflow-y:auto;padding:0;z-index:10;width:100%;overflow-x:hidden;", ""], (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["max-width:", ";"], width)));
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyleAvatarWithKebab,
  StyledAvatar,
  StyledAvatarButton,
  StyledAvatarPopUpContainer,
  StyledPopover
});
//# sourceMappingURL=AvatarPopup.styled.js.map